













import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class DigitalFlop extends Vue {
  @Prop() indData!: any;
}
